import { useTranslation } from 'next-i18next';
import { Button } from '@restworld/ui-ds-base';
import { BaseModal, CoverLetterQuickGuide } from '../../../';
import { jsx as _jsx } from "react/jsx-runtime";

function TipsFromOurTeamModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose;

  var _useTranslation = useTranslation('onboarding-page'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(BaseModal, {
    open: isOpen,
    onClose: onClose,
    footer: /*#__PURE__*/_jsx(Button, {
      fullwidth: true,
      onClick: onClose,
      children: t('okay_clear')
    }),
    children: /*#__PURE__*/_jsx(CoverLetterQuickGuide, {
      showCloseButton: false
    })
  });
}

export default TipsFromOurTeamModal;